module.exports = __webpack_public_path__ + "img/ITS-logo-icon-horizontal-reversed.5fa64b43.png";